import React from 'react'
import styles from "../Location.module.scss";
import { CAREERS_APPLY_ROUTE_URL, CATERING_CAFE_ZUPAS_URL, REACT_APP_CLOUD_FRONT } from '../../../constants';
const LocationGridSection = ({location}) => {
    return (
        <div>
            <div className={styles.HomeLoyaltyGridWrapper}>
                <div className={styles.InnerLayout}>
                    <div className={styles.innerDiv}>
                        <img
                            alt="Loyalty mobile app"
                            src={require("../../../images/loyaltyMobileApp.png")}
                            className={styles.innerImage}
                        />
                    </div>
                    <div className={styles.innerDiv}>
                        <div className={`${styles.innerDivContent} p-4`}>
                            <h4>Download The App</h4>
                            <p>
                                The Café Zupas Mobile App is your key to unlocking free food!
                                Earn and redeem points, save your favorite orders, and so much
                                more.
                            </p>
                            <div className='d-flex align-items-center gap-2 justify-content-center'>
                                <a
                                    href={'https://apps.apple.com/pk/app/caf%C3%A9-zupas-loyalty/id6448428217'}
                                    target={'_blank'}>
                                    <img src={require('../../../images/appStore.png')} width={150} />
                                </a>
                                <a href={'https://play.google.com/store/apps/details?id=com.cafezupasres.co&hl=en'} target={'_blank'}>
                                    <img src={require('../../../images/playStore.png')} width={150} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.InnerLayout}>
                    <div className={styles.innerDiv}>
                        <div className={`${styles.innerDivContent} p-4`}>
                            <h4>Chef-Crafted Catering</h4>
                            <p>
                                Feed groups of all sizes with easy-to-order trays and box
                                lunches that impress guests with delicious dishes made with
                                real, whole ingredients.
                            </p>
                            <a
                                className="btn btn-large mb-md-0 mb-3"
                                onClick={() => {
                                    const queryString = encodeURIComponent(JSON.stringify(location));

                                    // Redirect to the new domain with the query string
                                    const newTab = window.open(`${CATERING_CAFE_ZUPAS_URL}?data=${queryString}`, '_blank');
                                    newTab.focus(); // Optional: Focus on the new tab
                                }}
                                target={'_blank'}
                            >
                                Order catering
                            </a>
                        </div>
                    </div>
                    <div className={styles.innerDiv}>
                        <img
                            alt="Girls group"
                            src={require("../../../images/location/boxLunches.png")}
                            className={styles.innerImage}
                        />
                    </div>
                </div>
                <div className={styles.InnerLayout}>
                    <div className={styles.innerDiv}>
                        <img
                            alt="Loyalty mobile"
                            src={`${REACT_APP_CLOUD_FRONT}/images/career-overview/teamValue.png`}
                            className={styles.innerImage}
                        />
                    </div>
                    <div className={styles.innerDiv}>
                        <div className={`${styles.innerDivContent} p-4`}>
                            <h4>Join The Team</h4>
                            <p>
                                The secret ingredient to everything great about Café Zupas is
                                our team! Think you’d make a great addition?
                            </p>
                            <a
                                className="btn btn-large mb-md-0 mb-3"
                                target={"_blank"}
                                href={CAREERS_APPLY_ROUTE_URL}
                            >
                                {" "}
                                view jobs
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LocationGridSection